import { IObservableArray, makeAutoObservable, observable } from "mobx";
import { CheckArgs } from "../utils/checks/CheckArgsWithoutThrow";
import { TaskStore } from "./TaskStore";
import TaskIllustrationServerClient from "../ServerClients/TaskIllustrationServerClient";
import { TaskIllustrationIdsDTOType } from "../DTO/ServerResponseType/Task/TaskIllustration";

export class TaskIllustrationsStore {
  private root: TaskStore;

  /**
   * Task illustration id to disconnect it from the task and illustration id for viewing the illustration by the user
   */
  public taskIllustrationIds: IObservableArray<TaskIllustrationIdsDTOType> =
    observable.array([]);

  /**
   * Illustration id which the user has selected to add
   */
  public tempIllustrationIds: IObservableArray<string> = observable.array([]);

  constructor(root: TaskStore) {
    makeAutoObservable(this);
    this.root = root;
  }

  onChangeTempTaskIllustrationsIds = (illustrationId: string) => {
    // check illustration has already been selected
    let isIncludeIllustration =
      this.tempIllustrationIds.includes(illustrationId);

    if (isIncludeIllustration) this.tempIllustrationIds.remove(illustrationId);
    else this.tempIllustrationIds.push(illustrationId);
  };

  setIllustrations = (taskIllustrationIds: TaskIllustrationIdsDTOType[]) => {
    this.taskIllustrationIds.replace(taskIllustrationIds);
  };

  /**
   * Disconnect illustration from task and delete from task illustration ids
   * @param taskIllustrationId
   */
  disconnectIllustrationAsync = async (taskIllustrationId: string) => {
    TaskIllustrationServerClient.sendToDisconnectIllustrationFromTaskAsync(
      taskIllustrationId
    ).then(() => {
      this.deleteIllustrationByTaskIllustrationId(taskIllustrationId);
    });
  };

  /**
   * Connect illustrations to task
   */
  connectIllustrationsAsync = async () => {
    // filtering illustrations if it is already in the task
    let illustrationsToConnect = this.tempIllustrationIds.filter(
      (illustrationId) =>
        this.taskIllustrationIds.find(
          (el) => el.illustrationId === illustrationId
        ) === undefined
    );

    return Promise.all(
      illustrationsToConnect.map((illustrationId: string) => {
        return this.connectIllustrationAsync(illustrationId)
          .then((taskIllustrationId: string) => {
            this.pushIllustration({
              illustrationId: illustrationId,
              taskIllustrationId: taskIllustrationId,
            });
            this.onChangeTempTaskIllustrationsIds(illustrationId);
          })
          .catch((error) => {
            alert(error);
            console.log(error);
          });
      })
    );
  };

  pushIllustration = (illustrationIds: TaskIllustrationIdsDTOType) => {
    this.taskIllustrationIds.push(illustrationIds);
  };

  deleteIllustrationByTaskIllustrationId = (taskIllustrationId: string) => {
    this.taskIllustrationIds.replace(
      this.taskIllustrationIds.filter(
        (el: TaskIllustrationIdsDTOType) =>
          el.taskIllustrationId !== taskIllustrationId
      )
    );
  };

  deleteIllustrationByIllustrationId(illustrationId: string) {
    this.taskIllustrationIds.replace(
      this.taskIllustrationIds.filter(
        (el: TaskIllustrationIdsDTOType) => el.illustrationId !== illustrationId
      )
    );
  }

  /**
   * Connect illustration to task and add to task illustration ids
   */
  public connectIllustrationAsync = async (
    illustrationId: string
  ): Promise<string | never> => {
    let taskId = this.root.task.taskId;
    if (CheckArgs.CheckNullOrUndefinedOrEmptyString(taskId)) {
      console.log("Error: task was not created");
      throw Error("Task not exists");
    }

    return TaskIllustrationServerClient.sendToConnectIllustrationToTaskAsync(
      taskId!,
      illustrationId
    );
  };

  resetTempIllustrations() {
    this.tempIllustrationIds.replace(observable.array([]));
  }
}
